var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _path4, _path5, _circle, _circle2, _circle3, _circle4, _rect19, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowToIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 156,
    viewBox: "0 0 145 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 84.8819V20.9421C20 9.14329 29.6189 -0.366863 41.3523 0.0108764C52.5817 0.388616 61.3133 10.0988 61.3133 21.4976V84.8819C61.3133 86.7953 59.7682 88.3465 57.8623 88.3465H42.4692V114.626C42.5323 114.824 42.5598 115.034 42.5474 115.246L56.3024 149.253C56.649 150.111 56.2486 151.093 55.4085 151.447C55.2044 151.533 54.9906 151.575 54.7822 151.575C54.135 151.575 53.523 151.183 53.2597 150.535L42.4692 123.855V149.829C42.4692 150.776 41.6921 151.543 40.7346 151.543C39.7771 151.543 39 150.776 39 149.829V124.256L28.3715 150.536C28.1083 151.183 27.4963 151.575 26.8491 151.575C26.6407 151.575 26.4279 151.533 26.2228 151.447C25.3826 151.093 24.9823 150.111 25.3289 149.253L39 115.453V88.3465H23.5073C21.5922 88.3465 20.031 86.8043 20 84.8819Z",
    fill: "#969696"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8156 35.0786C48.0006 35.0786 53.8253 29.2618 53.8253 22.0865C53.8253 14.9111 48.0006 9.09436 40.8156 9.09436C33.6305 9.09436 27.8059 14.9111 27.8059 22.0865C27.8059 29.2618 33.6305 35.0786 40.8156 35.0786Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8159 28.5825C44.4084 28.5825 47.3207 25.6741 47.3207 22.0864C47.3207 18.4987 44.4084 15.5903 40.8159 15.5903C37.2234 15.5903 34.311 18.4987 34.311 22.0864C34.311 25.6741 37.2234 28.5825 40.8159 28.5825Z",
    fill: "#ACACAC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 22,
    width: 28,
    height: 45,
    rx: 8,
    fill: "#0E0333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 25,
    width: 22,
    height: 39,
    rx: 6,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 17,
    width: 2,
    height: 10,
    rx: 1,
    fill: "#0E0333"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 23,
    width: 2,
    height: 10,
    rx: 1,
    transform: "rotate(-90 36 23)",
    fill: "#0E0333"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 77,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0E0333"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 65,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0E0333"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 83,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0E0333"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 71,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0E0333"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 89,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0E0333"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 95,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0E0333"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 101,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0E0333"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 107,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0E0333"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 113,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0E0333"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 119,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0E0333"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 125,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0E0333"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 131,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0E0333"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 137,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0E0333"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 143,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0E0333"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 149,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0E0333"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    y: 156,
    width: 4,
    height: 97,
    rx: 2,
    transform: "rotate(-90 0 156)",
    fill: "#5C5C5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49 21.5C48.7239 21.5 48.5 21.7239 48.5 22C48.5 22.2761 48.7239 22.5 49 22.5V21.5ZM71.3536 22.3536C71.5488 22.1583 71.5488 21.8417 71.3536 21.6464L68.1716 18.4645C67.9763 18.2692 67.6597 18.2692 67.4645 18.4645C67.2692 18.6597 67.2692 18.9763 67.4645 19.1716L70.2929 22L67.4645 24.8284C67.2692 25.0237 67.2692 25.3403 67.4645 25.5355C67.6597 25.7308 67.9763 25.7308 68.1716 25.5355L71.3536 22.3536ZM49 22.5H71V21.5H49V22.5Z",
    fill: "#0E0333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.646 152.354C107.842 152.549 108.158 152.549 108.354 152.354L111.536 149.172C111.731 148.976 111.731 148.66 111.536 148.464C111.34 148.269 111.024 148.269 110.828 148.464L108 151.293L105.172 148.464C104.976 148.269 104.66 148.269 104.464 148.464C104.269 148.66 104.269 148.976 104.464 149.172L107.646 152.354ZM108.354 21.6464C108.158 21.4512 107.842 21.4512 107.646 21.6464L104.464 24.8284C104.269 25.0237 104.269 25.3403 104.464 25.5355C104.66 25.7308 104.976 25.7308 105.172 25.5355L108 22.7071L110.828 25.5355C111.024 25.7308 111.34 25.7308 111.536 25.5355C111.731 25.3403 111.731 25.0237 111.536 24.8284L108.354 21.6464ZM108.5 152L108.5 22L107.5 22L107.5 152L108.5 152Z",
    fill: "#0E0333"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 31.5,
    r: 2.5,
    fill: "#0E0333"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 31.5,
    r: 2.5,
    fill: "#0E0333"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 38.5,
    r: 2.5,
    fill: "#0E0333"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 38.5,
    r: 2.5,
    fill: "#0E0333"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 46,
    width: 14,
    height: 14,
    rx: 4,
    fill: "#0E0333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M123.02 86.2045C122.099 86.2045 121.307 85.9872 120.642 85.5526C119.977 85.1179 119.466 84.5192 119.108 83.7564C118.75 82.9936 118.571 82.1222 118.571 81.142C118.571 80.1449 118.754 79.2649 119.121 78.5021C119.491 77.7351 120.007 77.1364 120.667 76.706C121.332 76.2713 122.108 76.054 122.994 76.054C123.684 76.054 124.307 76.1818 124.861 76.4375C125.415 76.6932 125.868 77.0511 126.222 77.5114C126.576 77.9716 126.795 78.5085 126.881 79.1222H125.372C125.257 78.6747 125.001 78.2784 124.605 77.9332C124.213 77.5838 123.684 77.4091 123.02 77.4091C122.432 77.4091 121.916 77.5625 121.473 77.8693C121.034 78.1719 120.691 78.6001 120.444 79.1541C120.201 79.7038 120.079 80.3494 120.079 81.0909C120.079 81.8494 120.199 82.5099 120.437 83.0724C120.68 83.6349 121.021 84.0717 121.46 84.3828C121.903 84.6939 122.423 84.8494 123.02 84.8494C123.412 84.8494 123.768 84.7812 124.087 84.6449C124.407 84.5085 124.677 84.3125 124.899 84.0568C125.121 83.8011 125.278 83.4943 125.372 83.1364H126.881C126.795 83.7159 126.584 84.2379 126.248 84.7024C125.915 85.1626 125.474 85.5291 124.925 85.8018C124.379 86.0703 123.744 86.2045 123.02 86.2045ZM129.086 86V76.1818H130.543V77.7159H130.671C130.876 77.1918 131.206 76.7848 131.662 76.495C132.118 76.201 132.665 76.054 133.305 76.054C133.952 76.054 134.491 76.201 134.922 76.495C135.356 76.7848 135.695 77.1918 135.938 77.7159H136.04C136.292 77.2088 136.669 76.8061 137.172 76.5078C137.675 76.2053 138.278 76.054 138.981 76.054C139.858 76.054 140.577 76.3288 141.135 76.8786C141.693 77.424 141.972 78.2741 141.972 79.429V86H140.464V79.429C140.464 78.7045 140.265 78.1868 139.869 77.8757C139.473 77.5646 139.006 77.4091 138.469 77.4091C137.779 77.4091 137.244 77.6179 136.865 78.0355C136.486 78.4489 136.296 78.973 136.296 79.608V86H134.762V79.2756C134.762 78.7173 134.581 78.2678 134.219 77.9268C133.856 77.5817 133.39 77.4091 132.819 77.4091C132.427 77.4091 132.06 77.5135 131.719 77.7223C131.383 77.9311 131.11 78.2209 130.901 78.5916C130.697 78.9581 130.594 79.3821 130.594 79.8636V86H129.086Z",
    fill: "#0E0333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToIllustration);
export default __webpack_public_path__ + "static/media/how-to-illustration.646f0a096fed2a1b563928215638b4c0.svg";
export { ForwardRef as ReactComponent };